import { render, staticRenderFns } from "./realEstateEnterprisesCase.vue?vue&type=template&id=49887b00&scoped=true"
import script from "./realEstateEnterprisesCase.vue?vue&type=script&lang=js"
export * from "./realEstateEnterprisesCase.vue?vue&type=script&lang=js"
import style0 from "./realEstateEnterprisesCase.vue?vue&type=style&index=0&id=49887b00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49887b00",
  null
  
)

export default component.exports